import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// removes this message as part of the FG Clean up ( jfp_a11y_team_timeline_shift_incomplete_labels )
	shiftTimelineLeft: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.shift-timeline-left',
		defaultMessage: 'Shift timeline left',
		description:
			'Label for button which shifts the timeline to the left (date range to later date)',
	},
	// remove this message as part of the FG Clean up ( jfp_a11y_team_timeline_shift_incomplete_labels )
	shiftTimelineRight: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.shift-timeline-right',
		defaultMessage: 'Shift timeline right',
		description:
			'Label for button which shifts the timeline to the right (date range to earlier date)',
	},
	moveTimelineBack: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.move-timeline-back',
		defaultMessage: 'Go back',
		description: 'Label for button which moves the timeline back (date range to later date)',
	},
	moveTimelineAhead: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.move-timeline-ahead',
		defaultMessage: 'Move ahead',
		description: 'Label for button which moves the timeline ahead (date range to earlier date)',
	},
});
